<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Row style="height:15px;"></Row>
    <Row>
      <v-table
        :title="this.binance_blog_record_title"
        :title_info="this.binance_blog_record_info"
        :table_columns="this.binance_blog_record_table_columns"
        :table_data="this.binance_blog_record_table_data"
        :table_ref="this.binance_blog_record_ref"
        :max_height="700"
        :init_table="this.binance_blog_record_init_table_func"
        :table_name_array="this.binance_blog_name_array"
        :show_top="false"
        :table_page_size="50"
      ></v-table>
    </Row>
  </div>
</template>

<script>
import table_view from "../components/TableView.vue";

export default {
  name: "binance_blog_supervisor",
  components: {
    "v-table": table_view
  },
  data() {
    return {
      timer: null,
      table_title: "Binance公告监控",

      binance_blog_record_title: "",
      binance_blog_record_info: [],
      binance_blog_record_table_columns: [],
      binance_blog_record_table_data: [],
      binance_blog_record_ref: "binance_blog_record_ref",
      binance_blog_name_array: [
        "通知id",
        "时间",
        "通知标题",
        "通知链接",
        "通知内容",
        "类型",
      ]
    };
  },
  methods: {
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.load_tables_data(Date.parse(new Date()))
        }, interval);
      }
    },
    load_tables_data: async function(timestamp = "") {
      let binance_blog_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: {
            mode: "binance_blog_record",
            which_web_need: this.strategy_id,
            timestamp: timestamp
          }
        }
      );
      this.set_binance_blog_record_data(binance_blog_record_data);
    },
    binance_blog_record_init_table_func: function() {
      const name_array = this.binance_blog_name_array;
      this.binance_blog_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.binance_blog_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }

      this.binance_blog_record_table_columns[0]["width"] = 85;
      this.binance_blog_record_table_columns[1]["width"] = 155;
      this.binance_blog_record_table_columns[2]["width"] = 400;
      
      this.binance_blog_record_table_columns[5]["width"] = 85;
      this.binance_blog_record_table_columns[2]["tooltip"] = true;
      this.binance_blog_record_table_columns[3]["tooltip"] = true;
      //this.binance_blog_record_table_columns[4]["type"] = "html";
      this.binance_blog_record_table_columns[4]["tooltip"] = true;
      this.binance_blog_record_table_columns[5]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("普通") != -1 ? '#006633':'#ed4014'
              }
            },
            value
          )
        ]);
      };
    },
    set_binance_blog_record_data: function(data) {
      this.binance_blog_record_title = data["name"];
      
      for (var i = 0; i < data["data"].length; i++) {
        this.binance_blog_record_table_data.push(data["data"][i])
      }

      this.binance_blog_record_info = [
        { name: "总计通知数量 ", value: this.binance_blog_record_table_data.length },
      ];

    },
  },
  mounted() {
    this.strategy_id = this.$route.path.split("=")[1];
    this.load_tables_data()
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer(30000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>